<template>
    <div class="row mb-5">
        <div class="col-md-6 col-lg-4 d-flex align-items-center mb-2 mb-md-0" v-html="fieldText"></div>
        <div class="col-md-6 col-lg-8">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fieldText: String
    }
}
</script>